export const INVALID_PAYLOAD = "Invalid payload";
export const UNAUTHORIZED = "Unauthorized";
export const AUTHENTICATED = "Authenticated";
export const BACKEND_ERROR = "Something went wrong in the backend";
